import { researchData, calcResourceGatherTime, calcResearchBuildTime } from '../../data';
import { StateFastForward } from '../core';
import { makeTimelineEntry, makeInvalidEntry } from '../timelineEntries';
import { captureStateSnapshot } from '../snapshot';
import { waitWhile, drainShorterThan } from '../waits';

export const handleResearch = (state, timeline, recorder, action, index) => {
  const { payload } = action;
  const { planetId, tech } = payload;

  // Only one research empire-wide at a time.
  state = waitWhile(state, timeline, recorder, planetId, (s) => s.researchAction !== undefined, {
    captureSnapshots: true,
  });

  // Can't start research while any planet is mid-researchLab-upgrade.
  state = waitWhile(
    state,
    timeline,
    recorder,
    planetId,
    (s) => Object.values(s.planets).some((planet) => planet.buildAction && planet.buildAction.payload.building === 'researchLab'),
    { captureSnapshots: true }
  );

  const currentLevel = state.research[tech];
  const cost = researchData[tech].cost(currentLevel + 1);
  let gatherTime = calcResourceGatherTime(state, planetId, { ...cost });
  if (gatherTime < 0) {
    timeline.push(makeInvalidEntry(state, planetId, index, `Start ${researchData[tech].name} ${state.research[tech]}`));
    return state;
  }

  const drained = drainShorterThan(state, timeline, recorder, planetId, gatherTime, (s) =>
    calcResourceGatherTime(s, planetId, { ...cost })
  );
  state = drained.state;
  gatherTime = drained.threshold;

  const available = researchData[tech].available(state, planetId);
  if (!available) {
    timeline.push(makeInvalidEntry(state, planetId, index, `Start ${researchData[tech].name} ${state.research[tech]}`));
    return state;
  }

  if (gatherTime > 0) {
    const beforeGatherState = captureStateSnapshot(state, planetId);
    timeline.push(makeTimelineEntry('gather', state, { ...action, duration: gatherTime, index }, beforeGatherState));
    state = StateFastForward(state, planetId, gatherTime, recorder);
    timeline[timeline.length - 1].stateAfter = captureStateSnapshot(state, planetId);
  }

  const beforeResearchState = captureStateSnapshot(state, planetId);
  const planet = state.planets[planetId];
  const duration = calcResearchBuildTime(state, planetId, { ...cost }, researchData[tech].available);
  planet.resources.metal -= cost.metal;
  planet.resources.crystal -= cost.crystal;
  planet.resources.deuterium -= cost.deuterium;
  state.researchAction = { ...action, duration, index };
  state.planets[planetId] = planet;

  recorder.record(state, planetId, `Started ${researchData[tech].name} level ${state.research[tech] + 1}`);

  timeline.push(makeTimelineEntry('start', state, state.researchAction, beforeResearchState, captureStateSnapshot(state, planetId)));

  return state;
};
